.priceSelection {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.05);
  width: 100%;
  padding: var(--cxy-spacing-4) var(--cxy-spacing-2);
  border-radius: var(--cxy-border-radius-m);
  color: var(--cxy-color-content-default);
  max-width: 600px;
}
.priceSelection .term {
  font-size: var(--cxy-fontSize-m);
  line-height: var(--cxy-lineHeight-m);
}

.priceSelection .offerDisclaimer {
  display: none;
}

[data-fpsm-theme='gazzetta'] .priceSelection .offerDisclaimer {
  display: block;
  font-size: var(--cxy-fontSize-m);
  font-weight: var(--cxy-fontWeight-bold);
  color: var(--cxy-color-brand);
}

[data-fpsm-theme='whoscored'] .priceSelection .term {
  display: none;
}
.priceSelection .bestValue {
  font-size: var(--cxy-fontSize-m);
  font-weight: var(--cxy-fontWeight-bold);
  color: var(--cxy-color-brand);
  line-height: var(--cxy-lineHeight-m);
  min-height: 20px;
}
.priceSelection .price {
  font-weight: var(--cxy-fontWeight-bold);
  height: 50px;
}
.priceSelection .price .monthlyCost {
  font-size: 37px;
}
.priceSelection .paid {
  font-weight: var(--cxy-fontWeight-bold);
  margin-bottom: var(--cxy-spacing-3);
}
.priceSelection .subscribeButton {
  height: 48px;
  width: 90%;
  text-transform: uppercase;
  font-size: var(--cxy-fontSize-s);
}
.priceSelection .subscribeButton .fullText {
  display: none;
}
.priceSelection .subscribeButton .shortText {
  display: inline;
}
@media (--cxy-desktop) {
  .priceSelection .subscribeButton .fullText {
    display: inline;
  }
  .priceSelection .subscribeButton .shortText {
    display: none;
  }
}

@media (min-width: 801px) and (max-width: 1268px) {
  .priceSelection > .bestValue {
    display: none;
  }
  .priceSelection > .price {
    font-weight: var(--cxy-fontWeight-bold);
    height: 32px;
  }
  .priceSelection > .price .monthlyCost {
    font-size: var(--cxy-fontSize-l);
  }
  .priceSelection > .subscribeButton {
    height: 36px;
  }
}
.bestValueBorder {
  position: relative;
  border: 2px solid var(--cxy-color-content-default);
  border-radius: var(--cxy-border-radius-l);
  padding: var(--cxy-spacing-4);
}

.bestValueTag {
  position: absolute;
  top: -16px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--cxy-color-content-default);
  color: var(--cxy-color-content-dark);
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-bold);
  padding: var(--cxy-spacing-1) var(--cxy-spacing-3);
  border-radius: 50px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
}

[data-fpsm-theme='whoscored'] .priceSelection {
  background-color: var(--cxy-color-container-light);
  border: 2px solid var(--cxy-color-brand);
}

[data-fpsm-theme='gazzetta'] .priceSelection {
  background-color: var(--cxy-color-container-white);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
  font-size: var(--cxy-fontSize-m);
  font-weight: var(--cxy-fontWeight-bold);

  .price {
    font-size: var(--cxy-fontSize-xl);
    height: unset;

    .monthlyCost {
      font-size: 36px;
    }
  }

  .paid {
    font-size: var(--cxy-fontSize-xs);
  }

  .subscribeButton {
    max-width: 384px;
  }
}

[data-fpsm-theme='gazzetta'] {
  .bestValueBorder {
    border: 2px solid var(--cxy-color-brand);
  }
}

[data-fpsm-theme='gazzetta'] .bestValueTag {
  background-color: var(--cxy-color-brand);
  color: var(--cxy-color-content-dark);
}
